import { render, staticRenderFns } from "./size-choose.vue?vue&type=template&id=b61d878c&scoped=true"
import script from "./size-choose.vue?vue&type=script&lang=js"
export * from "./size-choose.vue?vue&type=script&lang=js"
import style0 from "./size-choose.vue?vue&type=style&index=0&id=b61d878c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b61d878c",
  null
  
)

export default component.exports